import {
  AccountingDeptRoles,
  PlnDeptRoles,
  PrdDeptRoles,
  PurDeptRoles,
  QlcDeptRoles,
  Role,
  SldDeptRoles,
  SupervisorRoles,
  WarDeptRoles,
} from './roles'

export const WarViewRoles = [
  Role.ADMIN,
  ...WarDeptRoles,
  ...QlcDeptRoles,
  ...PrdDeptRoles,
  ...PlnDeptRoles,
  ...SldDeptRoles,
  ...PurDeptRoles,
  ...AccountingDeptRoles,
  Role.QSS_OFFICER,
]

export const WarMovementViewRoles = [
  Role.ADMIN,
  Role.WAREHOUSE_OFFICER,
  Role.PRODUCTION_TECHNICIAN,
  ...SupervisorRoles,
  Role.QSS_OFFICER,
]

export const WarReportRoles = [
  Role.ADMIN,
  ...SupervisorRoles,
  Role.PRODUCTION_TECHNICIAN,
  Role.QSS_OFFICER,
]

export const WarModifyRoles = WarDeptRoles

export const Inv4310ModifyRoles = [
  Role.WAREHOUSE_SUPERVISOR,
  Role.WAREHOUSE_OFFICER,
  Role.PURCHASE_SUPERVISOR,
  Role.PURCHASE_OFFICER,
]

export const Inv3010ViewRoles = [
  Role.ADMIN_CKD,
  Role.ACCOUNTING_SUPERVISOR,
  Role.WAREHOUSE_SUPERVISOR,
  Role.WAREHOUSE_ADMIN,
]

export const Inv3020ViewRoles = [
  Role.ADMIN_CKD,
  Role.ACCOUNTING_SUPERVISOR,
  Role.WAREHOUSE_SUPERVISOR,
  Role.WAREHOUSE_ADMIN,
]

// Physical Inventory Count (INV3510) Permissions
export const Inv3510ViewRoles = [
  Role.ADMIN_CKD,
  Role.ACCOUNTING_SUPERVISOR,
  Role.WAREHOUSE_SUPERVISOR,
  Role.QSS_OFFICER,
]

export const Inv3510ModifyRoles = [
  Role.ADMIN,
  Role.ADMIN_CKD,
  Role.ACCOUNTING_SUPERVISOR,
]

export const Inv3510ApproveRoles = [Role.ADMIN, Role.WAREHOUSE_SUPERVISOR]

export const Inv1310ConfirmRoles = [
  ...WarDeptRoles,
  Role.PURCHASE_SUPERVISOR,
  Role.PURCHASE_OFFICER,
]

export const Inv1140CreateRoles = [
  Role.WAREHOUSE_ADMIN,
  Role.WAREHOUSE_SUPERVISOR,
  Role.WAREHOUSE_OFFICER,
]
